import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
} from 'components/ui/dropdown-menu';
import { Button } from 'components/ui/button';
import DownChevronIcon from 'components/icons/downchevron';
import { PAYMENT_CONFIG } from 'state/paymentConfig/type';
import usePaymentConfig from 'state/paymentConfig/hooks/usePaymentConfig';
import PageHeading from 'components/heading';

interface IProps {
  defaultProvider: PAYMENT_CONFIG.IProcessors | undefined;
  setDefaultProvider: Dispatch<
    SetStateAction<PAYMENT_CONFIG.IProcessors | undefined>
  >;
}

const ProviderDropdown = ({ defaultProvider, setDefaultProvider }: IProps) => {
  const { paymentConfig } = usePaymentConfig();
  const { filteredList } = paymentConfig;

  const [paymentProviderOptions, setPaymentProviderOptions] = useState<
    PAYMENT_CONFIG.IProcessors[]
  >([]);

  useEffect(() => {
    if (filteredList && filteredList?.length > 0) {
      setPaymentProviderOptions(filteredList);
    } else {
      setPaymentProviderOptions([]);
    }
  }, [filteredList]);

  return (
    <>
      <PageHeading level="h2" heading="Payment provider" className='mb-2' />
      <div className="w-60">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              data-testid="provider_dropdown"
              variant="outline"
              size="sm"
              rounded="base"
              className="w-80 justify-between font-normal"
            >
              <span>{defaultProvider?.processorName || 'Please select'}</span>
              <DownChevronIcon />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="w-80">
            {paymentProviderOptions?.map((item) => (
              <DropdownMenuItem
                key={item.processorId}
                onClick={() => setDefaultProvider(item)}
              >
                {item?.processorName}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </>
  );
};

export default ProviderDropdown;
